import React from 'react'
import { useSelector } from 'react-redux'
import { getProfile } from 'src/store/app.state.store'
import { getFullName } from 'utils/getFullName'
import { Popup } from 'components/Utility/Popup/Popup'
import { Arrow } from 'components/Utility/Arrow/Arrow'
import { Avatar } from 'components/Profile/Avatar/Avatar'
import { AccountPreview } from './AccountPreview'
import styles from './Account.module.scss'

type AccountProps = {
  onClick: () => void,
  previewActive: boolean,
  onClosePreview: () => void,
  onClickProfile: () => void,
  onClickSignOut: () => void,
  onClickAppointment: () => void,
}

/** Avatar and name in the header, opens the account popup */
export const Account: React.FC<AccountProps> = (props) => {
  const { onClick, previewActive, onClosePreview, onClickProfile, onClickSignOut, onClickAppointment } = props
  const user = useSelector(getProfile)

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick()
  }

  return (
    <div className={styles.account} onClick={handleClick}>
      <Avatar className={styles.avatar} user={user} />
      <div className={styles.accountText}>{user ? getFullName(user) : 'Войти'}</div>
      <div className={styles.previewContainer}>
        <Arrow className={styles.previewArrow} direction={previewActive ? 'down' : 'right'} />
        <Popup active={previewActive} onClose={onClosePreview}>
          <AccountPreview
            onClickProfile={onClickProfile}
            onClickSignOut={onClickSignOut}
            onClickAppointment={onClickAppointment}
          />
        </Popup>
      </div>
    </div>
  )
}
